import React, { useState } from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../config/i18n';

import './TextExcerptShowMore.css';

interface TextExcerptShowMoreProps {
  text: string;
  originalText: string | null;
  hasTranslation: boolean;
  showOriginalComment: boolean;
  separator?: string;
  maxLength: number;
}

const defaultSeparator = ' ';

export default function TextExcerptShowMore({
  text,
  originalText,
  hasTranslation,
  showOriginalComment,
  separator,
  maxLength,
}: TextExcerptShowMoreProps): JSX.Element {
  const [expanded, setExpanded] = useState(false);

  const textToDisplay =
    hasTranslation && showOriginalComment && originalText != null ? originalText : text;

  function toggleHide(event: React.MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();
    setExpanded(!expanded);
  }

  if (!textToDisplay || textToDisplay.length < maxLength) {
    return <div className="text-excerpt-show-more">{textToDisplay}</div>;
  }

  if (expanded) {
    return (
      <div className="text-excerpt-show-more">
        <div className="text-excerpt-show-more__text">{textToDisplay}</div>
        <div className="text-excerpt-show-more__link">
          <a href="" onClick={toggleHide}>
            {I18n.t('accommodation_reviews.hide')}
          </a>
        </div>
      </div>
    );
  }

  const shortenendText = [
    textToDisplay.substr(
      0,
      textToDisplay.lastIndexOf(separator != null ? separator : defaultSeparator, maxLength),
    ),
    '…',
  ].join(' ');
  return (
    <div className="text-excerpt-show-more">
      <div className="text-excerpt-show-more__text">{shortenendText}</div>
      <div className="text-excerpt-show-more__link">
        <a href="" onClick={toggleHide}>
          {I18n.t('accommodation_reviews.show_more')}
        </a>
      </div>
    </div>
  );
}

const defaultProps: Pick<TextExcerptShowMoreProps, 'separator'> = {
  separator: defaultSeparator,
};

TextExcerptShowMore.defaultProps = defaultProps;
